import React from "react";
import Modal from 'react-awesome-modal';
import {observer} from "mobx-react";
import ibsStore from '../Stores/IbsSurveyStore'
import sharedStore from '../Stores/SharedStore'
import pabsStore from "../Stores/SurveyStore";
import {SurveyTypeURL} from "../../Enums/constants";
import { getActivityDefsFileCtrl, getHelpFileCtrl } from "../../control";
import { isUK } from "../../ibsHelper";
import { getMorningstarHelpFile } from '../../Services/IBS/IbsService'

const HelpModal = observer(() => {
  const closeHelpModal = () => {
    sharedStore.showHelpModal = false;
  }

  const clickGetMorningstarHelpFile = () => {
    getMorningstarHelpFile()
  }

  const clickGetHelpFile = () => {
    //console.log("getting excel temp here")
    getHelpFileCtrl()
  }

  const clickGetActivityDefsFile = () => {
    getActivityDefsFileCtrl()
  }
    let helpModalContent = null;


    let dcMsHelpLink = null;
    if (pabsStore.surveyTypeUrl === SurveyTypeURL.DC) {
        dcMsHelpLink = <React.Fragment>    
            <br /> <span style={{ color: '#1a71c1', cursor: 'pointer' }} onClick={() => clickGetMorningstarHelpFile()}>FAQ - Third party data</span>
        </React.Fragment>
    }

    // PABS surveys only show Contact Us (no Instructions section)
    if (pabsStore.surveyTypeUrl === SurveyTypeURL.PABS_UK ||
        pabsStore.surveyTypeUrl === SurveyTypeURL.PABS ||
        pabsStore.surveyTypeUrl === SurveyTypeURL.PABS_LG) {
        helpModalContent = <React.Fragment>
            <div className="helpModal">
              <h3><i className="fa fa-question-circle"></i> Help
                <span onClick={closeHelpModal} className="close-button topright">&times;</span>
              </h3>

              <hr />
            <span>Please feel free to contact us at any time with questions. Quick tips are available by clicking on the help icon in the online survey.<br />
              More detailed instructions are available in Adobe PDF format below.
            </span><br /><br />


            <div className="row">
              <div className="col-md-6">
                <h4>Contact Us</h4>
                <a href='mailto:Production@explorecem.com'>Production@explorecem.com</a>
              </div>
              <div className="col-md-6" style={{ lineHeight: '40px' }}>
                <h4>Instructions and Definitions</h4>
                <span style={{ color: '#1a71c1', cursor: 'pointer' }} onClick={() => clickGetHelpFile()}>Download Cost Instructions PDF</span><br />
                <span style={{ color: '#1a71c1', cursor: 'pointer' }} onClick={() => clickGetActivityDefsFile()}>Download Activity Definitions PDF</span>
              </div>
            </div>

            </div> </React.Fragment>;
    }
    else {
    
        if (isUK()) {
          helpModalContent = <React.Fragment>
            <div className="helpModal">
              <h3><i className="fa fa-question-circle"></i> Help
                <span onClick={closeHelpModal} className="close-button topright">&times;</span>
              </h3>

              <hr />
              <span>Please feel free to contact us at any time with questions. Quick tips are available by clicking on the help in the online survey. More detailed
                instructions are available in Adobe PDF format below.</span><br /><br />


              <div className="row">
                <div className="col-md-6">
                  <h4>Contact Us</h4>
                  <a href='mailto:CEM@explorecem.com'>CEM@explorecem.com</a><br />
                  <a href='mailto:johns@explorecem.com'>John Simmonds</a><br /> +44 203 887 9289 (office)<br />+44 7880 656099 (mobile)


                </div>
                <div className="col-md-6" style={{ lineHeight: '40px' }}>
                  <h4>Instructions and Definitions</h4>
                  <span style={{ color: '#1a71c1', cursor: 'pointer' }} onClick={() => clickGetHelpFile()}>Download Instructions PDF</span>
                  {dcMsHelpLink}
                </div>
              </div>

            </div> </React.Fragment>;
        }
        else {
          helpModalContent = <React.Fragment>
            <div className="helpModal">
              <h3><i className="fa fa-question-circle"></i> Help
                <span onClick={closeHelpModal} className="close-button topright">&times;</span>
              </h3>

              <hr />
              <span>Please feel free to contact us at any time with questions. Quick tips are available by clicking on the help in the online survey. More detailed
                instructions are available in Adobe PDF format below.</span><br /><br />


              <div className="row">
                <div className="col-md-6">
                  <h4>Contact Us</h4>
                  <a href='mailto:Production@explorecem.com'>Production@explorecem.com</a>
                </div>
                <div className="col-md-6" style={{ lineHeight: '40px' }}>
                  <h4>Instructions and Definitions</h4>
                  <span style={{ color: '#1a71c1', cursor: 'pointer' }} onClick={() => clickGetHelpFile()}>Download Instructions PDF</span>
                  {dcMsHelpLink}
                </div>
              </div>

            </div> </React.Fragment>;
        }
    }
    return (
        <React.Fragment>
            <section>

                <Modal
                    visible={sharedStore.showHelpModal}
                    width="800"
                    height="430"
                    effect="fadeInDown"
                    onClickAway={closeHelpModal}
                >
                    { helpModalContent }
                </Modal>
            </section>

        </React.Fragment>
    );

});

export default HelpModal;

//Yvette@explorecem.com or by phone at 416-369-0812
//<a href={process.env.PUBLIC_URL + '/PABS_Help_Activity_Defns.pdf'} download>Download Activity Definitions PDF</a> <br />
